module.exports = __webpack_public_path__ + "static/media/screen1.97b91ef3.png";